import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { AccusationComponent } from "./components/AccusationComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { LeaderboardComponent } from "./components/LeaderboardComponent";
import { HighScoreComponent } from "./components/HighscoreComponent";
import { MapComponent } from "./components/MapComponent";
import { soundsettings } from "./components/SoundComponent";
import { GameAccountComponent } from "./components/AccountComponent";

window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-accusate", AccusationComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-leaderboard", LeaderboardComponent);
window.customElements.define("game-highscores", HighScoreComponent);
window.customElements.define("game-map", MapComponent);
window.customElements.define("sound-settings", soundsettings as CustomElementConstructor);
window.customElements.define("game-account", GameAccountComponent);
